module.exports = [{
      plugin: require('/Users/samlarsen-disney/Documents/sld.codes/sld-memes/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/cat.jpg"},
    },{
      plugin: require('/Users/samlarsen-disney/Documents/sld.codes/sld-memes/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/samlarsen-disney/Documents/sld.codes/sld-memes/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
